import { NgModule } from '@angular/core';
import { angularProvidersBuilder } from '@harmony/angular';
import { CommonProvider } from '../common/common.provider';
import { AuthZohoDefaultProvider, AuthZohoProvider } from './auth-zoho.provider';

@NgModule({
  providers: angularProvidersBuilder({
    provide: AuthZohoProvider,
    deps: [CommonProvider],
    useFactory: (common: CommonProvider) => new AuthZohoDefaultProvider(common, window),
  }).build(),
})
export class AuthZohoProviderModule {}
